module.exports = __webpack_public_path__ + "img/grad-10.95372a82.png";